import React, { useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  RiLuggageDepositFill,
  IoIosArrowForward,
  FiDownload,
} from "react-icons/all";

export default function Deposit_canva() {
  // For deposit button
  const [deposit, setDeposit] = useState(false);
  const handleDepositClose = () => setDeposit(false);
  const handleDepositShow = () => setDeposit(true);

  return (
    <>
      <div className="dp_canva">
        <Button variant="warning" onClick={handleDepositShow}>
          <i>
            <FiDownload />
          </i>
          Deposit{" "}
        </Button>
      </div>
      <Offcanvas
        show={deposit}
        onHide={handleDepositClose}
        backdrop={true}
        placement="end"
        style={{ color: "#000" }}
        className="dp_can_ofcn"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Fund Your Wallet</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <p className="fw-bold">I have crypto assets</p>
            <div>
              <Link to="/deposit" onClick={()=>(setDeposit(false))}>
                <div className="d-flex align-items-center gap-2">
                  <i>
                    {" "}
                    <RiLuggageDepositFill />{" "}
                  </i>
                  <div>
                    <h5>Deposit Crypto</h5>
                    <span>
                      Deposit your existing crypto assets via the blockchain.
                    </span>
                  </div>
                  <div>
                    <i>
                      {" "}
                      <IoIosArrowForward />{" "}
                    </i>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div>
            <p className="fw-bold">I want to purchase crypto assets</p>
            <div>
              <Link to="/deposit">
                <div className="d-flex align-items-center gap-2">
                  <i>
                    {" "}
                    <RiLuggageDepositFill />{" "}
                  </i>
                  <div>
                    <h5>Buy Crypto</h5>
                    <span>
                      Buy crypto directly with cash, hassle-free and suggested
                      for new users.
                    </span>
                  </div>
                  <div>
                    <i>
                      <IoIosArrowForward />
                    </i>
                  </div>
                </div>
              </Link>
            </div>

            <div>
              <Link to="/deposit">
                <div className="d-flex align-items-center gap-2">
                  <i>
                    <RiLuggageDepositFill />
                  </i>
                  <div>
                    <h5>Bank Deposit</h5>
                    <span>
                      Deposit money (EUR, etc.) from your bank account and buy
                      crypto with cash balance later.
                    </span>
                  </div>
                  <div>
                    <i>
                      <IoIosArrowForward />
                    </i>
                  </div>
                </div>
              </Link>
            </div>

            <div>
              <Link to="/deposit">
                <div className="d-flex align-items-center gap-2">
                  <i>
                    {" "}
                    <RiLuggageDepositFill />{" "}
                  </i>
                  <div>
                    <h5>Receive Crypto</h5>
                    <span>
                      Easily and securely receive crypto from other Binance
                      accounts.
                    </span>
                  </div>
                  <div>
                    <i>
                      {" "}
                      <IoIosArrowForward />{" "}
                    </i>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
